// @flow

import React, { type Node } from 'react';
import {
  Body,
  Content,
} from '../../../organisms/shared-styled-components';
import styled from 'styled-components';
import { MerchantLogo } from '../../../organisms/merchant-info';
import { MobileTotalAmount } from '../../../organisms/mobile-total-amount';
import {
  getMerchant,
  getCountry,
  getWithholdTaxes,
  usePendingIncomingPayment,
} from '@tectonics/prs/incoming-payment';
import { getReceiptAmountLocalTotal } from '@tectonics/prs/receipts/receipt';
import { useCurrentReceipt } from '@tectonics/prs/receipts';
import { getMoneyFormat } from '@tectonics/look-and-feel/shopify/commons/money-format';
import { amountToCurrencyString } from '@tectonics/prs/money';
import { getName as getMerchantName } from '@tectonics/prs/merchant';
import {getExpirationDetailsFromPayment} from '@tectonics/prs/incoming-payment/get-expiration-datetime';

const RedirectPageContent = React.lazy(() => import('../redirect-page'));
const DebinWithholdTaxesPage = React.lazy(() => import('../debin-withhold-taxes-page'));

export function DebinPage(): Node {
  const incomingPayment = usePendingIncomingPayment();
  const withholdTaxes = getWithholdTaxes(incomingPayment);
  if (withholdTaxes === 'default') {
    return <DebinRedirectContent />;
  }

  return <DebinWithholdTaxesPage />;
}

function DebinRedirectContent(): Node {
  const incomingPayment = usePendingIncomingPayment();
  const receipt = useCurrentReceipt();
  const decimalFormat = getMoneyFormat(getCountry(incomingPayment));
  const formatAmount = amountToCurrencyString(decimalFormat);
  const merchant = getMerchant(incomingPayment);
  const { weekDay, formattedDate, expireDate, expireTime } = getExpirationDetailsFromPayment(incomingPayment);

  if (incomingPayment['redirect_url'] === undefined) {
    return (
      <Content>
        <MerchantLogo height="100px" />
        <MobileTotalAmount />
        <Body>
          <Title>
            Tu solicitud de Debin por {formatAmount(getReceiptAmountLocalTotal(receipt))} ha sido enviada exitosamente \o/
          </Title>
          <Text>
            Ve a tu banca en línea o app bancaria y aprueba la solicitud de Debin por {formatAmount(getReceiptAmountLocalTotal(receipt))} pesos argentinos realizada a nombre de {getMerchantName(merchant)} que estará vigente unicamente hasta el {weekDay}, {formattedDate}, ({expireDate}) a las {expireTime}.
          </Text>
          <Text>
            Revisa el apartado de &quot;Debin pendiente&quot;. En caso de no estar dando de alta, realiza el procedimiento en 5 minutos dentro de tu banca en línea.
          </Text>
        </Body>
      </Content>
    );
  } else {
    return <RedirectPageContent />;
  }
}

const Title = styled.div`
  padding: 32px 16px;
  font-size: 1.8em;
  font-family: ${props => props.theme.fontFamily.display};
`;
const Text = styled.div`
  padding: 32px 16px;
  font-size: 1.1em;
  font-family: ${props => props.theme.fontFamily.display};
  border-top: 1px solid #eeeeee;
`;
